import { render, staticRenderFns } from "./xpsexpressorder.vue?vue&type=template&id=77ce205a"
import script from "./xpsexpressorder.vue?vue&type=script&lang=js"
export * from "./xpsexpressorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports